import { makeStyles } from "@material-ui/core/styles";

const commonStyles = makeStyles((theme) => ({
  responsiveText: {
    fontSize: "1rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.25rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1.5rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "2rem",
    },
  },
  responsiveTitleTextSize: {
    fontSize: "12px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "22px",
    },
  },

  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexEnd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  flexColumn: {
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  flexAndGap8Px: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  datePickerDiv: {
    width: "45px",
    overflowY: "hidden",
    height: "4.3rem",
    marginTop: "-10px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "normal",
  },
  datePickerComponent: {
    // marginLeft: "4px",
    // marginBottom: "2.2px",
    padding: "9px",
    // borderRadius: "5px",
    backgroundColor: theme.palette.primary.main,
    width: "100%",
    minHeight: "28px",
    borderRadius: "10px",
  },
  statusColor: {
    borderRadius: "50%",
    display: "inline-block",
    height: "13px",
    width: "13px",
    border: "2px solid",
    borderColor: theme.palette.borderColor,
  },

  //custom widgets styles
  smallWidgetRoot: {
    backgroundColor: "#252A38",
    borderRadius: "20px",
    padding: "12px",
    height: "215px",
  },
  bigWidgetRoot: {
    backgroundColor: "#252A38",
    borderRadius: "20px",
    padding: "12px",
    height: "400px",
  },
  widgetTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  widgetsTitle: {
    fontSize: "12px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
    },
  },

  //custom page
  customPageTableWidth: {
    width: "100%",
    overflow: "auto",
    height: "calc(100vh - 160px)",
  },
  dropdownContainer: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "0px 5px",
  },
  select: {
    padding: "0.2px 6px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
    height: "40px",
    color: "white",
    cursor: "pointer",
  },
  dropdownContainerForTable: {
    // backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    padding: "0px",
  },
  selectForTable: {
    border: "1px solid transparent",
    padding: "4px 6px",
    borderRadius: "20px",
    width: "100%",
    height: "40px",
    color: "white",
    cursor: "pointer",
  },
}));

export default commonStyles;
